(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["love-chocolate-action-video"] && !window.DesignMode) return;
  try {
    

  new Swiper(`[id="video-action"] .videosSwiper`, {
    slidesPerView: "auto",  // Valor padrão, pode ser ajustado para responsivo
    spaceBetween: 24,  // Espaçamento entre os slides
    pagination: {
      el: `[id="video-action"] .videosPagination`,
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      600: {
        slidesPerView: 2,  // Dois vídeos por vez no mobile
      },
      1024: {
        slidesPerView: 4,  // Todos os slides visíveis em telas maiores que 1024px
        spaceBetween: 24,  // Ajuste o espaço entre os slides conforme necessário
      }
    },
    on: {
      slideChange: function () {
        document.querySelectorAll(`[id="video-action"] .videoSlide`).forEach(function (element) {
          element.querySelector("video").pause();
          element.classList.remove("active")
        });
      },
    }
  });

  
  document.querySelectorAll(`[id="video-action"] .videoSlide`).forEach(function (element) {
      element.addEventListener("click", function () {
          if (this.classList.contains("active")) {
              this.querySelector("video").pause();
              this.classList.remove("active")
          } else {
              // stop if there is another active
              if (document.querySelector(".videoSlide.active")) {
                  document.querySelector(".videoSlide.active").querySelector("video").pause();
                  document.querySelector(".videoSlide.active").classList.remove("active")
              }
              this.querySelector("video").play();
              this.classList.add("active");
          }
      });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["love-chocolate-up-sell-pop-up"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Configuration - Replace with your actual checkout button selector
    const checkoutButtonSelector = '#buyButtonLove';

    // Elements
    const modal = document.getElementById('upsellModal');
    const closeBtn = modal.querySelector('.upsell-close');
    const overlay = modal.querySelector('.upsell-overlay');
    const continueBtn = modal.querySelector('.upsell-continue');
    const totalSpan = modal.querySelector('.upsell-total span');

    // Find checkout buttons
    const checkoutButtons = document.querySelectorAll(checkoutButtonSelector);

    // Cart state
    const upsellCart = [];

    // Use event delegation instead of direct event binding
    document.body.addEventListener('click', function (event) {
      // Check if the clicked element or any of its parents match the selector
      const button = event.target.closest(checkoutButtonSelector);
      if (button) {
        event.preventDefault();
        modal.style.display = 'block';
      }
    });

    // Close modal function
    function closeModal() {
      modal.style.display = 'none';
      // Redirect to cart page
      window.location.href = '/cart';
    }

    // Event listeners for closing the modal
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
    continueBtn.addEventListener('click', closeModal);

    // Prevent modal content from closing when clicking inside
    const modalContent = modal.querySelector('.upsell-modal');
    modalContent.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Handle quantity controls
    const quantityDecreaseBtns = modal.querySelectorAll('.quantity-decrease');
    const quantityIncreaseBtns = modal.querySelectorAll('.quantity-increase');
    const quantityInputs = modal.querySelectorAll('.quantity-input');

    quantityDecreaseBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const input = this.parentNode.querySelector('.quantity-input');
        if (parseInt(input.value) > 0) {
          input.value = parseInt(input.value) - 1;
          updateTotal();
        }
      });
    });

    quantityIncreaseBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const input = this.parentNode.querySelector('.quantity-input');
        input.value = parseInt(input.value) + 1;
        updateTotal();
      });
    });

    quantityInputs.forEach((input) => {
      input.addEventListener('change', updateTotal);
    });

    // Add to cart functionality
    const addToCartBtns = modal.querySelectorAll('.add-to-cart-btn');

    addToCartBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const product = this.closest('.upsell-product');
        const quantity = parseInt(product.querySelector('.quantity-input').value);

        // Get variant ID either from select or hidden input
        let variantId;
        const variantSelect = product.querySelector('.variant-select');
        const hiddenVariantInput = product.querySelector('.variant-id');

        if (variantSelect) {
          variantId = variantSelect.value;
        } else if (hiddenVariantInput) {
          variantId = hiddenVariantInput.value;
        }

        if (quantity > 0 && variantId) {
          // Add to Shopify cart using AJAX
          addToCart(variantId, quantity, btn);
        } else if (!variantId && variantSelect) {
          alert('Por favor, selecione uma opção.');
        }
      });
    });

    // Add to Shopify cart function
    function addToCart(variantId, quantity, button) {
      // Visual feedback
      button.textContent = 'ADICIONANDO...';
      button.disabled = true;

      // Shopify AJAX API call
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: { _cart_up_sell: true }
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // Success
          button.textContent = 'ADICIONADO';
          button.style.backgroundColor = '#3d9c40';
          button.style.color = 'white';

          // Track in upsell cart for total calculation
          upsellCart.push({
            variantId: variantId,
            quantity: quantity,
            price: parseFloat(data.price) / 100,
          });

          updateTotal();

          // Reset button after 2 seconds
          setTimeout(() => {
            button.textContent = 'ADICIONAR';
            button.style.backgroundColor = '#dd1d1d';
            button.style.color = 'white';
            button.disabled = false;
          }, 2000);
        })
        .catch((error) => {
          // Error handling
          console.error('Error:', error);
          button.textContent = 'ERRO';
          button.style.backgroundColor = '#ff0000';

          // Reset button after 2 seconds
          setTimeout(() => {
            button.textContent = 'ADICIONAR';
            button.style.backgroundColor = '#dd1d1d';
            button.style.color = 'white';
            button.disabled = false;
          }, 2000);
        });
    }

    // Update total
    function updateTotal() {
      let total = 0;

      // Calculate from upsell cart items
      if (upsellCart.length > 0) {
        total = upsellCart.reduce((sum, item) => sum + item.price * item.quantity, 0);
      }

      // Display the formatted total
      totalSpan.textContent = `R$ ${total.toFixed(2)}`;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
